import { LENDER_ID, PLATFORM_NAME, RegexConfig } from '../types/regix';
import { Dimensions, Linking, Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info'
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { store } from '@app/store/newstore';
import { userAuthenticated } from '@app/store/slices/authSlice';
import CryptoJS from 'react-native-crypto-js';
import { createNavigationContainerRef } from '@react-navigation/native';
import { QUERY_PARAMS, STORE_KEY } from '@app/configs/constants';
import { endpoints, isProduction, VoltWebSiteBaseLink } from '@app/api/apis';
import ROUTE from '@app/navigationApp/routes';

export enum OpenNewTabTargetType {
    blank = "_blank",
    self = "_self",
    parent = "_parent",
    top = "_top",
    popup = "popup"
}

export enum SCREEN_SIZE {
    /**
     * Screen Width <576px
     */
    X_SMALL = "extra_small",
    /**
     * Screen Width >=576px
     */
    SMALL = "small",
    /**
     * Screen Width >=768px
     */
    MEDIUM = "medium",
    /**
     * Screen Width >=992px
     */
    LARGE = "large",
    /**
     * Screen Width >=1200px
     */
    X_LARGE = "extra_large"
}

export const navigationRef = createNavigationContainerRef();

export const phonePayRoutes = [ROUTE.VERIFY_EMAIL, ROUTE.MF_FETCH_PORTFOLIO, ROUTE.MF_PLEDGE_PORTFOLIO, ROUTE.SET_CREDIT_LIMIT, ROUTE.CHECKING_LIMIT, ROUTE.KYC_PAN_VERIFICATION]


export const maskBankAccountNumber = (accountNo: string) => {
  if (accountNo.length > 4) {
    const showString = accountNo.slice(accountNo.length - 4);
    let maskString = '';
    let index = accountNo.length - 4;
    while (index > 0) {
      maskString += 'X';
      index--;
    }
    return maskString.concat(showString);
  }
  return accountNo;
};

export function sortByMonthDescending(array: string[]): string[] {
  if (Platform.OS !== 'web') {
    const months = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };
    const sortedArray = array.sort((a, b) => {
      const [monthA, yearA] = a.split('-');
      const [monthB, yearB] = b.split('-');
      const dateA = new Date(Number(yearA), months[monthA]);
      const dateB = new Date(Number(yearB), months[monthB]);
      return dateB.getTime() - dateA.getTime();
    });

    return sortedArray;
  }
  const sortedArray = array.sort((a, b) => {
    const dateA = new Date(`${a}-01`);
    const dateB = new Date(`${b}-01`);
    return dateB.getTime() - dateA.getTime();
  });

  return sortedArray;
}

export const groupByMonth = (arrayOfObjects: any[]) => {
  const groupedData = {};
  if (
    arrayOfObjects === undefined ||
    arrayOfObjects === null ||
    arrayOfObjects?.length === 0
  ) {
    return;
  }
  let sortedGroupedData = [];
  arrayOfObjects.forEach(obj => {
    const epochValue = obj.settledOn;
    const dateObj = new Date(epochValue);
    const monthName = dateObj.toLocaleString('en-US', { month: 'long' });
    const yearMonthKey = `${monthName}-${dateObj.getFullYear()}`;

    if (!groupedData[yearMonthKey]) {
      groupedData[yearMonthKey] = [];
    }

    groupedData[yearMonthKey].push(obj);
  });
  Object.keys(groupedData).forEach(attr => {
    if (Array.isArray(groupedData[attr])) {
      groupedData[attr].sort((a, b) => {
        const dateA = new Date(a.settledOn);
        const dateB = new Date(b.settledOn);
        return dateB.getTime() - dateA.getTime();
      });
    } else {
      console.error('Settled trans data is not an array');
    }
  });
  const sortedMonthArray = sortByMonthDescending(Object.keys(groupedData));
  sortedMonthArray.forEach((itemKey, index) => {
    sortedGroupedData.push({
      monthYear: `${itemKey}`,
      data: groupedData[itemKey],
    });
  });
  return sortedGroupedData;
};

export const returnDateInString = (epochDate: number) => {
  const { date, month, year } = convertISODate(epochDate);
  let suffix = 'th';

  if (date === '1' || date === '21' || date === '31') {
    suffix = 'st';
  } else if (date === '2' || date === '22') {
    suffix = 'nd';
  } else if (date === '3' || date === '23') {
    suffix = 'rd';
  }

  return `${date}${suffix} ${month.slice(0, 3)}, ${year}`;
};

export const returnDateInStringV2 = (epochDate: number) => {
  const { date, month, year } = convertISODate(epochDate);
  return `${date} ${month} ${year}`;
};

export const returnDate = (epochDate: number) => {
  const { date, month, year } = convertISODate(epochDate);
  return `${date} ${month}`;
};

export const convertISODate = (timeString: string | number) => {
  // timeString = "2023-02-28T10:30:52.119Z";
  const dateObj = new Date(timeString);
  const date = dateObj.toLocaleDateString('en-US', { day: 'numeric' });
  const month = dateObj.toLocaleDateString('en-US', { month: 'long' });
  const year = dateObj.toLocaleDateString('en-US', { year: 'numeric' });
  return { date, month, year };
};

export const getEpochTime = (epochTimestamp: number) => {
  console.warn('epoachTIme', epochTimestamp);
  const date = new Date(epochTimestamp); // Convert to milliseconds
  const formattedTime = date.toLocaleString('en-IN', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
  return formattedTime;
};
export const addCommasToNumber = (num: number) => {
  if (num) {
    {
      return num
        ?.toString()
        .replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
    }
  } else {
    return '0';
  }
};

export const isPanValid = (pan: string) => {
  const panRegex = new RegExp(RegexConfig.PAN);
  return panRegex.test(pan);
};

export const isPhoneNumberValid = (phoneNumber: string) => {
  const phoneNumberRegex = new RegExp(RegexConfig.NEW_MOBILE);
  return phoneNumberRegex.test(phoneNumber);
};

interface sumObject {
  [key: string]: number;
}

export const sumObjectValues = (obj: sumObject): number => {
  if (obj) {
    return Object.entries(obj).reduce((sum, [_, value]) => sum + value, 0);
  }
  return 0;
};

export const getScreenType = (screenWidth?: number): SCREEN_SIZE => {
  const screenWidthX = screenWidth || Dimensions.get('window').width;
  if (screenWidthX < 576) {
    return SCREEN_SIZE.X_SMALL;
  }
  if (screenWidthX < 768) {
    return SCREEN_SIZE.SMALL;
  }
  if (screenWidthX < 992) {
    return SCREEN_SIZE.MEDIUM;
  }
  if (screenWidthX < 1200) {
    return SCREEN_SIZE.LARGE;
  }
  if (screenWidthX >= 1200) {
    return SCREEN_SIZE.X_LARGE;
  }

  return SCREEN_SIZE.X_SMALL;
};

export const isMobile = (
	screenType: SCREEN_SIZE,
) =>
	screenType === SCREEN_SIZE.X_SMALL ||
	screenType === SCREEN_SIZE.SMALL;

export const isFromAndroidWebview = () => {
  const isWebView = navigator?.userAgent?.includes('wv');

  console.warn('IS FROM WEBVIEW', isWebView);

  return Platform.OS === 'web' ? isWebView : false;
};

export const getRazorpayKey = () => {
  let key = ''
  key = isProduction ? 'rzp_live_nN5S5ZnatVKUFw' : 'rzp_test_E2TJNdTgbYHwxm';
  return key;
}
export const handlePayment = async(
  user,
  amount,
  color,
  preferredMethod,
  collectionId,
  navigateToBase,
  timeout,
  network,
  currentOrderId,
  key,
  setDatastore,
  redirectingRoute
) => {
  let routeId = 'proceedButton';
  if(redirectingRoute === ROUTE.OUTSTANDING_DUES) {
      routeId = 'manageLimit';
  }
  const options = {
    description: '',
    image: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Favicon.png",
    currency: "INR",
    key: key,
    amount: `${amount * 100}`,
    name: "DSP Finance Pvt Ltd",
    order_id: currentOrderId,
    prefill: {
      name: `${user?.user?.fullName}`,
      email: `${user?.linkedBorrowerAccounts[0]?.accountHolderEmail}`,
      contact: `${user?.user?.phoneNumber}`,
    },
    method: {
      netbanking: preferredMethod.includes('netbanking'),
      upi: preferredMethod.includes('upi'),
      card: preferredMethod.includes('card'),
      wallet: false,
      emi: false,
      paylater: false,
    },
    theme: {
       color: color ,
    },
    timeout:timeout,
    retry:{
      enabled:true,
      max_count:4,
    },
    send_sms_hash: true,
    card: {
      types: ['RUPAY',]
    },
    modal: {
      remember_customer: true,
      ondismiss: function(){
          setDatastore(redirectingRoute, routeId, <ButtonProps>{
              loading: false
          })
          navigateToBase(ROUTE.PAYMENT_CALLBACK, {collectionId:collectionId,dspPaymentStatus:DSP_PAYMENT_STATUS.CANCELLED,currentOrderId,redirectingRoute})
      }
    }
  };

  try {
      const data = await RazorpayCheckout.open(options);
      navigateToBase(ROUTE.PAYMENT_CALLBACK, {collectionId: collectionId})
  } catch (error) {
      navigateToBase(ROUTE.PAYMENT_CALLBACK, {collectionId: collectionId,dspPaymentStatus:DSP_PAYMENT_STATUS.CANCELLED,currentOrderId,redirectingRoute})
  }
};

export const RAZOR_PAY_PREFERRED_METHOD = {
  LESS_THAN_2K: ['upi', 'card'],
  LESS_THAN_100K: ['upi','netbanking','card',],
  DEFAULT: ['netbanking','card'],
}


export const getAutoDebitDate = (date?: string) => {
  let resultDate = '';
  switch (Number.parseInt(date)) {
    case 1:
      resultDate = `${date}st of every month`;
    break;
  case 2:
      resultDate = `${date}nd of every month`;
    break;
  case 3:
      resultDate = `${date}rd of every month`;
      break;
    default:
      resultDate = `${date}th of every month`;
    break;
  }

  return resultDate;
};

export const isWeb = () => {
  return Platform.OS === 'web';
};

export const isAndroid = () => {
  return Platform.OS === 'android';
};

export const isIos = () => {
  return Platform.OS === 'ios';
};

export const isFromiOSBrowser = () => {
  if (Platform.OS === 'web') {
    const userAgent = window.navigator.userAgent;
    return userAgent.includes('iPhone');
  }
};

export const isFromAndroidBrowser = () => {
  if (Platform.OS === 'web') {
    const userAgent = window.navigator.userAgent;
    return userAgent.includes('Android');
  }
};

export const convertToTitleCase = (inputString: string) => {
  // Split the input string into an array of words
  const words = inputString.split(' ');

  // Initialize an empty array to store the corrected words
  const correctedWords = [];

  // Loop through each word
  for (const word of words) {
    // Convert the word to lowercase, except for the first character
    const correctedWord =
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    // Add the corrected word to the array
    correctedWords.push(correctedWord);
  }

  // Join the corrected words to form the final title-cased string
  const titleCasedString = correctedWords.join(' ');

  return titleCasedString;
};

export const openNewTabDC = (
  url,
  targetType = OpenNewTabTargetType.blank,
  config = {
    width: 600,
    height: 600,
    target: 'Volt Money',
  },
) => {
  if (Platform.OS === 'web') {
    if (
      targetType === OpenNewTabTargetType.popup &&
      config &&
      config.width &&
      config.height &&
      config.target
    ) {
      const left = screen.width / 2 - config.width / 2;
      const top = screen.height / 2 - config.height / 2;
      window.open(
        url,
        `${config.target}`,
        `height=${config.height},width=${config.width}. top=${top}, left=${left}`,
      );
    } else {
      window.open(url, targetType);
    }
  } else {
    Linking.openURL(url);
  }
};

export const getParameters: (url: string) => {
  [key in string]: string
} = (url: string) => {
  if (url) {
      const params = {}
      const paramString = url.split('?')[1]
      const queryString = new URLSearchParams(paramString)
      for (const pair of queryString.entries()) {
          params[pair[0].includes('/') ? pair[0].split('/')[1] : pair[0]] =
              pair[1].includes('/') ? pair[1].split('/')[0] : pair[1]
      }
      return params
  }
  return {}
}

export const parseURL = (url:string) => {
    const parsed = new URL(url);
    const replaceKey = {
      plj:"isPLJ",
      uid:'isPgCallback',
      redirect:"shouldRedirect",
      sts:"skipToStep",
      showFlexi:'takeToFlexiPay',
      ref:'partnerReferralCode',
      sl:'isMfdShareLink'
    }

    const queryParams: { [key: string]: any } = {};
    for (const [key, value] of parsed.searchParams.entries()) {
      const parmKey = replaceKey[key]??key
      queryParams[parmKey] = booleanParseCorrection(decodeURIComponent(value));
    }
    queryParams.route = parsed.pathname.split('/').filter(Boolean).pop() || '';
    return queryParams
}

export function parseParameters(url: string): { [key: string]: any } {
  const params: { [key: string]: any } = {};
  const paramStr = url.slice(url.indexOf('?') + 1);
  const replaceKey = {
    plj:"isPLJ",
    uid:'isPgCallback',
    redirect:"shouldRedirect",
    sts:"skipToStep",
    showFlexi:'takeToFlexiPay',
    ref:'partnerReferralCode',
    sl:'isMfdShareLink'
  }
  paramStr.split('&').forEach(param => {
    const [key, value] = param.split('=');
    // @ts-ignore
    const parmKey = replaceKey[key]??key
    params[parmKey] = booleanParseCorrection(decodeURIComponent(value));
  });

  return params;
}

export const removeQueryParams = (url, params) => {
  var urlParts = url.split('?');
  if (urlParts.length >= 2) {
      var baseUrl = urlParts.shift(); // Get base URL without query params
      var queryParams = urlParts.join('?').split('&'); // Get query params as an array
      var updatedParams = queryParams.filter(function(param) {
          var paramName = param.split('=')[0]; // Get parameter name
          return !params.includes(paramName); // Exclude params specified in the 'params' array
      });
      return baseUrl + (updatedParams.length > 0 ? '?' + updatedParams.join('&') : ''); // Reconstruct URL
  }
  return url;
}

const booleanParseCorrection = (val) => {
  try {
    return JSON.parse(val) // throws an error
  } catch (e) {
    return (val==="" || val==="undefined" || val==="null") ? null :val // catches error
  }
}



export const convertEpochToDateWithoutYear = timeStamp => {
  const date = new Date(timeStamp * 1000);

  // Define an array of month names
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // Extract the day, month, and year from the date
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  // Create the formatted date string
  const formattedDate = `${day} ${month}`;
  return formattedDate;
};

export const alphabetsAndDotRegex = /^[a-zA-Z.\s]*$/;

export function formatEpoch(epoch) {
  const date = new Date(epoch); // Convert to milliseconds

  // Define options for formatting the date
  const dateOptions = {
    day: 'numeric',
    month: 'short',
    timeZone: 'Asia/Kolkata',
  };

  // Define options for formatting the time
  const timeOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  };

  // Format date and time separately
  //@ts-ignore
  const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(
    date,
  );
  //@ts-ignore
  const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(
    date,
  );

  // Convert time format from "2:30 PM" to "2:30pm"
  const formattedTimeLowerCase = formattedTime
    .replace(' AM', 'am')
    .replace(' PM', 'pm');

  // Return the formatted date and time in the desired format
  return `${formattedDate}, ${formattedTimeLowerCase}`;
}

export function formatEpochIntoYear(epoch) {
  // Create a new Date object from the epoch time
  const date = new Date(epoch); // Convert from seconds to milliseconds

  // Define options for formatting the date (excluding time)
  const dateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  // Format the date part using toLocaleString
  //@ts-ignore
  const formattedDatePart = date.toLocaleString('en-GB', dateOptions);

  // Extract and format the time part separately
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const period = hours >= 12 ? 'PM' : 'AM';

  // Convert hours from 24-hour to 12-hour format and pad with leading zero if necessary
  hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour clock
  const paddedHours = hours.toString().padStart(2, '0');

  // Combine the date and time parts into the final formatted date string
  const formattedDate = `${formattedDatePart} at ${paddedHours}:${minutes} ${period}`;

  return formattedDate;
}

export const isFromTDLPlatform = () => {
  if (Platform.OS === 'web') {
    const url = window.location.href || '';
    const params = getParameters(url);
    const platformCode = params?.platform || '';
    if (platformCode === PLATFORM_NAME.TDL) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const addSuffix = day => {
  if (day >= 11 && day <= 13) {
    return 'th';
  }
  switch (day % 10) {
  case 1:
    return 'st';
  case 2:
    return 'nd';
    case 3:
    return 'rd';
  default:
    return 'th';
  }
};


export const openURL = (url : string) => {
  if(Platform.OS === 'web') {
    window.open(url)
  }
  else {
    Linking.canOpenURL(url).then((canOpen) => {
      if(canOpen) {
        Linking.openURL(url)
      }
    })
  }
}

export const getUniqueDeviceId = async (): Promise<string> => {
  try {
    const uniqueId = await DeviceInfo.getUniqueId();
    return uniqueId;
  } catch (err) {
    return ""
  }
}

export const getDeviceName = () => {
  return DeviceInfo.getBrand()
}

export const setAppHeader = async (token:string) => {
    if (Platform.OS === 'web') {
      let expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 30);
      let expires = expirationDate.toUTCString();
      document.cookie = `access_token=${token}; path=/;${window.location.protocol === 'https:' ? 'secure;SameSite=None' : ''}`//secure flag is added to make sure cookie is only sent over https
      document.cookie = `expires=${expires};` ;
      const params = Platform.OS === 'web' ? getParameters(window.location.href):{};
      const isFromPartnerApp = params?.isFromPartnerApp;
      const platformCode = params?.platform;
      let requestHeaderAppPlatform = ''
      if (platformCode) {
          requestHeaderAppPlatform = platformCode
      } else if (isFromPartnerApp) {
        requestHeaderAppPlatform = "VOLT_PARTNER_ANDROID_APP"
      } else {
        requestHeaderAppPlatform = "VOLT_WEB_APP"
      }
      axios.defaults.headers.common['X-AppPlatform'] = requestHeaderAppPlatform
      const isAccessTokenInCookiPreset = document.cookie.split(';').some((item) => item.trim().startsWith('access_token='));
      if(!isAccessTokenInCookiPreset && isIframeCheck()){
        await AsyncStorage.setItem('access_token',token);
      }
    }
    else{
      await AsyncStorage.setItem('access_token',token);
    }
    store.dispatch(userAuthenticated({accessToken:token}))
    axios.defaults.headers.common.Authorization = 'Bearer ' + token;
}

export const isCookieExpirated = () => {
  const isCookiPreset = document.cookie.split(';').some((item) => item.trim().startsWith('expires='));
  if(isCookiPreset){
    const cookieExpiration = document.cookie.split(';').find((item) => item.trim().startsWith('expires='));
    const expirationDate = new Date(cookieExpiration.split('=')[1]);
    const currentDate = new Date();
    return currentDate > expirationDate
  } else{
    return false
  } 
}



export const getParamsLink = (url: string, append = false) => {
  const params = Platform.OS === 'web' && url ? getParameters(url) : {};

  let resultString = '';
  let localStoredParams = {};

  // check if params exist in localstorage if not present in query string
  const utm_campaign = params?.utm_campaign;
  const utm_content = params?.utm_content;
  const utm_id = params?.utm_id;
  const utm_medium = params?.utm_medium;
  const utm_source = params?.utm_source;
  const cachedUtm = localStorage.getItem('UTM_PARAMS');


  if (utm_campaign || utm_content || utm_id || utm_medium || utm_source) {
      Object.keys(params).forEach(param => {
          //store google utm params in localStorage
          if (isGoogleUTMParams(param)) {
              localStoredParams = {
                  ...localStoredParams,
                  time: addDaysToEpochTime(Date.now().valueOf(), 28),
                  [`${param}`]: params[param],
              };
          }
          if (param !== 'time') {
              console.log("param 123: ", param);
              resultString += `${param}=${params[`${param}`]}&`;
          }
      });
      localStorage.removeItem('UTM_PARAMS');
      localStoredParams &&
      localStorage.setItem(
          'UTM_PARAMS',
          JSON.stringify(localStoredParams),
      );
  } else {
      if (cachedUtm) {
          const cachedUtmJson = JSON.parse(cachedUtm);
          if (cachedUtmJson?.time && Date.now().valueOf() <= cachedUtmJson.time) {
              Object.keys(cachedUtmJson).forEach(param => {
                  //store google utm params in localStorage
                  if (param === 'time') {
                      //
                  } else {
                      resultString += `${param}=${cachedUtmJson[`${param}`]}&`;
                  }
              });
          } else {
              //remove google utm params in localStorage when token expires
              localStorage.removeItem('UTM_PARAMS');
          }
      } else {
          Object.keys(params).forEach(param => {
              //store google utm params in localStorage
              resultString += `${param}=${params[`${param}`]}&`;
              console.log("resultString without utm and cache utm 123: ", resultString);
          });
      }
  }
  console.log("result string 123: ", resultString);
  return append === true ? `${resultString}` : `?${resultString}`;
};


export enum GoogleUtmParams {
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_CONTENT = 'utm_content',
  UTM_ID = 'utm_id',
  UTM_MEDIUM = 'utm_medium',
  UTM_SOURCE = 'utm_source',
}

export const isGoogleUTMParams: (param: string) => boolean = param => {
  if (
      param === GoogleUtmParams.UTM_SOURCE ||
      param === GoogleUtmParams.UTM_CONTENT ||
      param === GoogleUtmParams.UTM_ID ||
      param === GoogleUtmParams.UTM_CAMPAIGN ||
      param === GoogleUtmParams.UTM_MEDIUM
  ) {
      return true;
  }
  return false;
};

export const addDaysToEpochTime = (epochTime: number, days: number) => {
  const date = new Date(epochTime);
  const dateAfterAddingDays = date.setDate(date.getDate() + days);
  return dateAfterAddingDays.valueOf();
};

export const encrypt = async (text: string) => {
	if (!text) {
		return '';
	}
	const ivMaterial = 'globalaesvectors';
	const keyMaterial =
		'jXn2r5u8x/A?D(G+KbPeSgVkYp3s6v9y';

	let key = CryptoJS.enc.Utf8.parse(keyMaterial);
	let iv = CryptoJS.enc.Utf8.parse(ivMaterial);
	let ciphertext1 = CryptoJS.AES.encrypt(
		text,
		key,
		{ iv: iv, padding: CryptoJS.pad.Pkcs7 },
	); // default values: CBC, PKCS#7 padding

	return CryptoJS.enc.Base64.stringify(
		ciphertext1.ciphertext,
	);
};

export const decrypt = async (text: string) => {
	if (!text) {
		return '';
	}
	text = text.replace('-', '+').replace('_', '/');
	const decodedText =
		CryptoJS.enc.Base64.parse(text);

	const ivMaterial = 'globalaesvectors';
	const keyMaterial =
		'G-KaPdSgVkYp3s5v8y/B?E(H+MbQeThW';

	let key = CryptoJS.enc.Utf8.parse(keyMaterial);
	let iv = CryptoJS.enc.Utf8.parse(ivMaterial);
	let ciphertext1 = CryptoJS.AES.decrypt(
		<any>{
			ciphertext: decodedText,
		},
		key,
		{
			iv: iv,
			padding: CryptoJS.pad.Pkcs7,
		},
	); // default values: CBC, PKCS#7 padding
	const result =
		CryptoJS.enc.Utf8.stringify(ciphertext1);

	return result;
};

export const isEncrypted = (url: string) => {
	if (url.startsWith('https://api.voltmoney.in')) {
		return true;
	} else {
		return false;
	}
};

export const checkColor = (defaultColor:string)=>{
  if(Platform.OS==='web'){
    const params = getParameters(window.location.href);
    const primaryColor = params?.primaryColor;
    return primaryColor?`#${primaryColor}`:defaultColor;
  }
  return defaultColor;
}

export const useDarkMode = ()=>{
  if (Platform.OS === 'web') {
    const params = new URLSearchParams(window.location.search);
    return params.get('isDarkMode') === 'true';
  }
  return false
}

export const isIframeCheck = (): boolean => {
  try {
      return window.self !== window.top;
  } catch (e) {
      return true;
  }
}

export const truncateFullName = (fullName: string, lengthToTruncateName: number)=> {
  if (!fullName || fullName.length <= lengthToTruncateName) return [fullName, ""];

  let splitIndex = lengthToTruncateName;
  let nextSpaceIndex = fullName.lastIndexOf(" ", lengthToTruncateName);

  if (nextSpaceIndex !== -1) {
    splitIndex = nextSpaceIndex;
  }

  return [fullName.substring(0, splitIndex), fullName.substring(splitIndex).trim()];
}

export const BIOMETRIC_USER_CANCELLED = [
  'Authentication canceled',
  'Authentication cancelled',
  'Face unlock canceled by user',
];

export const biometricLocalPermission = "biometric_permission"



export const getLenderRepayDate = (rawDate: string) => {
  const date = Number.parseInt(rawDate);

  if (isNaN(date)) return '';

  const getOrdinalSuffix = (n: number): string => {
    if ([11, 12, 13].includes(n % 100)) return `${n}th`;
    switch (n % 10) {
      case 1: return `${n}st`;
      case 2: return `${n}nd`;
      case 3: return `${n}rd`;
      default: return `${n}th`;
    }
  };

  return `${getOrdinalSuffix(date)} of every month`;
}



export const getDateMonthYearFromEpochFromMicroseconds = (epochNumber: number) => {

    if (!epochNumber) return ""; // Handle undefined case

    const newDateToPick = new Date(epochNumber * 1000); // JavaScript automatically adjusts to local timezone
    const displayDate = newDateToPick.getDate().toString().padStart(2, '0');
    const dateName = `${displayDate}${addSuffix(Number(displayDate))}`;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const getMonthName = newDateToPick.getMonth();
    const currentYear = newDateToPick.getFullYear();

    return `${dateName} ${monthNames[getMonthName]}, ${currentYear}`;

}

export function getMonthNumber(monthName) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
        "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    return monthNames.indexOf(monthName) + 1;
}

export const formatEpochToDateString = (epochNumber?: number) => {
    if (!epochNumber) return ""; // Handle undefined case

    // First method: get formatted date string like "02nd Apr, 2024"
    const newDateToPick = new Date(epochNumber);
    const displayDate = newDateToPick.getDate().toString().padStart(2, '0');
    const dateName = `${displayDate}${addSuffix(Number(displayDate))}`;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const getMonthName = newDateToPick.getMonth();
    const currentYear = newDateToPick.getFullYear();
    const dateString = `${dateName} ${monthNames[getMonthName]}, ${currentYear}`;

    // Second method: convert "02nd Apr, 2024" -> "02-04-2024"
    const [dayWithSuffix, monthName, year] = dateString.replace(',', '').split(' ');
    const day = dayWithSuffix.replace(/(st|nd|rd|th)/, '');
    const month = getMonthNumber(monthName);
    const paddedDay = day.padStart(2, '0');
    const paddedMonth = month.toString().padStart(2, '0');
    const formattedDate = `${paddedDay}-${paddedMonth}-${year}`;

    return formattedDate;
};

export const removeUrlParamsWithoutReload = () => {
  const url = window?.location?.protocol + "//" + window?.location?.host + window?.location?.pathname;
  window?.history?.replaceState({ path: url }, '', url);

}
export enum CreditApplicationStepId {
  MF_FETCH_PORTFOLIO = 'MF_FETCH_PORTFOLIO',
  MF_PLEDGE_PORTFOLIO = 'MF_PLEDGE_PORTFOLIO',
  KYC_CKYC = 'KYC_CKYC',
  KYC_AADHAAR_VERIFICATION = 'KYC_AADHAAR_VERIFICATION',
  KYC_DOCUMENT_UPLOAD = 'KYC_DOCUMENT_UPLOAD',
  KYC_DOCUMENT_UPLOAD_POI = 'KYC_DOCUMENT_UPLOAD_POI',
  KYC_DOCUMENT_UPLOAD_POA = 'KYC_DOCUMENT_UPLOAD_POA',
  KYC_PAN_VERIFICATION = 'KYC_PAN_VERIFICATION',
  KYC_PHOTO_VERIFICATION = 'KYC_PHOTO_VERIFICATION',
  KYC_DIGIO_DIGILOCKER = 'KYC_DIGIO_DIGILOCKER',
  DIGIO_AGREEMENT_SIGN = 'DIGIO_AGREEMENT_SIGN',
  DIGIO_MANDATE_SIGN = 'DIGIO_MANDATE_SIGN',
  KYC_SUMMARY = 'KYC_SUMMARY',
  KYC_ADDITIONAL_DETAILS = 'KYC_ADDITIONAL_DETAILS',
  AGREEMENT_SIGN = 'AGREEMENT_SIGN',
  BANK_ACCOUNT_VERIFICATION = 'BANK_ACCOUNT_VERIFICATION',
  MANDATE_SETUP = 'MANDATE_SETUP',
  CREDIT_APPROVAL = 'CREDIT_APPROVAL',
  COMMUNICATION = 'COMMUNICATION',
  KYC_DOCUMENTS = 'KYC_DOCUMENTS',
  CO_BORROWER_PAN_DETAILS = 'CO_BORROWER_PAN_DETAILS',
  CO_BORROWER_CKYC = 'CO_BORROWER_CKYC',
  CO_BORROWER_ADDITIONAL_DETAILS = 'CO_BORROWER_ADDITIONAL_DETAILS',
  CO_BORROWER_POA_DOCUMENT_UPLOAD = 'CO_BORROWER_POA_DOCUMENT_UPLOAD',
  CO_BORROWER_POI_DOCUMENT_UPLOAD = 'CO_BORROWER_POI_DOCUMENT_UPLOAD',
  CO_BORROWER_KYC_SUMMARY = 'CO_BORROWER_KYC_SUMMARY',
  CO_BORROWER_KYC_DOCUMENTS = 'CO_BORROWER_KYC_DOCUMENTS',
  CHECK_CUSTOMER_ELIGIBILITY = 'CHECK_CUSTOMER_ELIGIBILITY',
  TATA_MANDATE = 'TATA_MANDATE',
  CIBIL_CHECK = 'CIBIL_CHECK',
  OFFER_SELECTION = 'OFFER_SELECTION',
  REVIEW_KFS = 'REVIEW_KFS',
  DOCUMENTS = 'DOCUMENTS',
  LOAN_CONTRACT = 'LOAN_CONTRACT'
}

export enum StepperStateToken {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  SKIPPED = "SKIPPED",
  FAILED = "FAILED",
  BLOCKED = "BLOCKED",
  PENDING_CALLBACK = "PENDING_CALLBACK",
  PENDING_MANUAL_VERIFICATION = "PENDING_MANUAL_VERIFICATION",
  PENDING_VERIFICATION = "PENDING_VERIFICATION"
}

export const nextStepId = ({
  userDetails,
  currentStepId,
  isFetchFirstTime = false
} :{
  userDetails: any,
  currentStepId: string,
  isFetchFirstTime?: boolean
}) => {
  const stepStatusMap = userDetails?.linkedApplications[0]?.stepStatusMap;
    //MF_PLEDGE_PORTFOLIO
    if(currentStepId === CreditApplicationStepId.MF_PLEDGE_PORTFOLIO) {
        if (isFetchFirstTime) {
            return {
                routeId: ROUTE.CHECKING_LIMIT,
                params: {},
            }
        } else if(stepStatusMap.MF_PLEDGE_PORTFOLIO === StepperStateToken.IN_PROGRESS){
            return {
                routeId: ROUTE.PLEDGE_CONFIRMATION,
                params: {},
            }
        } else {
            return {
                routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                params: {},
            }
        }
    }

    return {
      routeId: ROUTE.SPLASH_SCREEN,
      params: {},
    }
}

export const roundDownToNearestHundred = (num: number) => {
  return Math.floor(num / 100) * 100
}

export const getTotalLimit = (
  availableCAS: any[],
  isinNavMap: any,
  isinLTVMap: any
) => {
    let sum = 0;
    availableCAS.forEach((item) => {
      sum =
        sum +
        roundDownToNearestHundred(
          item.pledgedUnits * isinNavMap[item.isinNo] * isinLTVMap[item.isinNo]
        );
    });
    return sum;
};

export const isFirstSetCreditLimitVisit = (availableCAS: any[]) => {
    return availableCAS.every(asset => asset.isPledged);
} 

export const getActualLimit = (
  availableCAS: any[],
  isinNavMap: any,
  isinLTVMap: any
) => {
    let sum = 0;
    availableCAS.forEach((item) => {
      sum =
        sum +
        roundDownToNearestHundred(
          item.totalAvailableUnits *
            isinNavMap[item.isinNo] *
            isinLTVMap[item.isinNo]
        );
    });
    return sum;
};

export const getPortfolioValue = (
  availableCAS: any[],
  isinNavMap: any,
) => {
  let sum = 0;
  availableCAS.forEach((item) => {
    sum =
        sum +
        roundDownToNearestHundred(
            item.totalAvailableUnits * isinNavMap[item.isinNo]
        );
  });
  return sum;
};

export const getDesiredValue = (
  availableCAS: any[],
  isinNavMap: any,
) => {
  let sum = 0;
  availableCAS.forEach((item) => {
    sum =
        sum +
        roundDownToNearestHundred(
            item.pledgedUnits * isinNavMap[item.isinNo]
        );
  });
  return sum;
};

export const getUpdateAvailableCAS = (
  amountRequired: number,
  availableCAS: any[],
  isinNavMap: any,
  isinLTVMap: any
) => {
  const updateAvailableCAS = [];
  for (let i = 0; i < availableCAS.length; i++) {
    const item = availableCAS[i];
    const individualAmount = getTotalLimit([item], isinNavMap, isinLTVMap);
    if (amountRequired >= individualAmount) {
      updateAvailableCAS.push(item);
      amountRequired = amountRequired - individualAmount;
    } else {
      const ratio = amountRequired / individualAmount;
      const newItem = {
        ...item,
        pledgedUnits: Math.ceil(item.totalAvailableUnits * ratio * 1000) / 1000,
      };
      updateAvailableCAS.push(newItem);
      amountRequired = 0;
    }
  }

  // if (amountRequired > 0) {
  //   /// throw error
  //   return [];
  // }
  return updateAvailableCAS;
};

export const addPrefixToMonth = (date?: string) => {
  let resultDate = ''
  switch (Number.parseInt(date)) {
    case 1:
      resultDate = `${date}st of every month`
      break;
    case 2:
      resultDate = `${date}nd of every month`
      break;
    case 3:
      resultDate = `${date}rd of every month`
      break;
    default:
      resultDate = `${date}th of every month`
      break;
  }

  return resultDate;
}

export const removeFCMTokenAndUpdateServer = async (_userId?: string) => {
  await AsyncStorage.removeItem(STORE_KEY.FCM_TOKEN);
  await AsyncStorage.removeItem(STORE_KEY.FCM_USER_ID);
}

export enum APPLICATION_STATUS {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  BLOCKED = 'BLOCKED',
  DENIED = 'DENIED',
}

export enum REPAYMENT_COLLECTION_TYPE {
  LOAN_EXPIRED_DUE_REPAYMENT = 'LOAN_EXPIRED_DUE_REPAYMENT',
  PRINCIPAL_REPAYMENT = 'PRINCIPAL_REPAYMENT',
  IN_APP_INTEREST_COLLECTION = 'IN_APP_INTEREST_COLLECTION',
  SHORTFALL_REPAYMENT = 'SHORTFALL_REPAYMENT',
  FORECLOSURE = 'FORECLOSURE'
}

export const truncateToThreeDecimals = (value: any) => {
  return Math.trunc(value * 1000) / 1000;
}

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
  "July", "Aug", "Sept", "Oct", "Nov", "Dec"
];

export const getDateMonthYearWithoutSuffixCommaFromEpoch = (epochNumber?: number) => {
  if(epochNumber === null || epochNumber === undefined) return '';
  const newDateToPick = new Date(epochNumber)
  const displayDate = newDateToPick.getDate()
  const getMonthName = newDateToPick.getMonth()
  const currentYear = newDateToPick.getFullYear();
  return `${displayDate} ${monthNames[getMonthName]} ${currentYear}`

}

export const addRupeesCommasToNumber = (num: number) => {
  if(num){
    let isNegative = num < 0;
    let absNum = Math.abs(num);
    let formattedNum = absNum.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',')
    return (isNegative ? "-₹" : "₹") + formattedNum;
  }
  else {
    return "₹0"
  }
}

export enum FORECLOSURE_HANDLING {
  UNLIEN_IN_PROCESS = 'UNLIEN_IN_PROCESS',
  DISBURSAL_IN_PROCESS = 'DISBURSAL_IN_PROCESS',
  REPAYMENT_IN_PROCESS = 'REPAYMENT_IN_PROCESS',
  FORECLOSURE_BUSINESS_HOUR_CHECK = 'FORECLOSURE_BUSINESS_HOUR_CHECK',
  FORECLOSURE_NOT_ALLOWED_LOAN_EXPIRED = 'FORECLOSURE_NOT_ALLOWED_LOAN_EXPIRED',
  FORECLOSURE_NOT_ALLOWED_RENEWAL_IN_PROGRESS = 'FORECLOSURE_NOT_ALLOWED_RENEWAL_IN_PROGRESS',
  FORECLOSURE_NOT_ALLOWED_FROM_LENDER = 'FORECLOSURE_NOT_ALLOWED_FROM_LENDER',
  BAD_REQUEST_RESOURCE_NOT_FOUND ='BAD_REQUEST_RESOURCE_NOT_FOUND',
  BAD_REQUEST_POLICY_VIOLATION = 'BAD_REQUEST_POLICY_VIOLATION',
}

export enum FORECLOSURE_STATUS {
  IN_REVIEW = 'IN_REVIEW',
  QUEUED = 'QUEUED',
  REQUESTED = 'REQUESTED',
  PENDING_LENDER_APPROVAL = 'PENDING_LENDER_APPROVAL',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED'
}

export const roundToTwoDecimalPlaces = (num:any) => {
  const parsedNum = parseFloat(num);
  if (isNaN(parsedNum)) {
    return 0;
  } else {
    return parseFloat(parsedNum.toFixed(2));
  }
}

export const convertEpochToCustomFormat = (epochTime: number): string => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const date = new Date(epochTime); // No need to multiply by 1000 for milliseconds
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month}, ${year}`;
}

export declare enum InterestBounceType {
  NORMAL = "NORMAL",
  DATE_BREACHED = "DATE_BREACHED",
  HARD_DATE_BREACHED = "HARD_DATE_BREACHED",
  BOUNCED = "BOUNCED"
}

export enum INTEREST_REPAYMENT_STATUS {
  AWAITING_MANDATE_STATUS = 'AWAITING_MANDATE_STATUS',
  DUE = 'DUE',
  FAILED = 'FAILED',
  OVERDUE = 'OVERDUE',
  SETTLED = 'SETTLED'
}

export enum CREDIT_STATUS {
  REQUESTED = 'REQUESTED',
  APPROVED_APPLICATION_PENDING = 'APPROVED_APPLICATION_PENDING',
  PENDING_DISBURSAL_APPROVAL = 'PENDING_DISBURSAL_APPROVAL',
  PENDING_LODGEMENT = 'PENDING_LODGEMENT',
  APPROVED_NOT_DISBURSED = 'APPROVED_NOT_DISBURSED',
  ACTIVE = 'ACTIVE',
  PENDING_CLOSURE = 'PENDING_CLOSURE',
  CLOSED = 'CLOSED',
}

export const showHelpAndSupportField = (userDetails:any) => {
  const lenderId = userDetails?.linkedCredits[0]?.lendingPartnerId;
  const creditStatus = userDetails?.linkedCredits[0]?.creditStatus;
  if(lenderId?.toLowerCase() === LENDER_ID.BAJAJ){
    return false;
  }
  else if(creditStatus === CREDIT_STATUS.ACTIVE || creditStatus === CREDIT_STATUS.APPROVED_NOT_DISBURSED) return true;
  else return false;
}

export enum FAQ_TYPE {
  NESTED_DESCRIPTION = 'nestedDescription',
  DESCRIPTIONS = 'descriptions',
  EXAMPLES = 'examples',
  ARRAY_EXAMPLES = 'arrayExamples',
  NESTED_EXAMPLE_DESCRIPTION = 'nestedExampleDescription',
  OTHER_DESCRIPTIONS = 'otherDescriptions',
  CLOSE_ACCOUNT = 'closeAccount',
  BUTTON = 'button',
}

export enum REPAY_TITLE {
  REAPAY_YOUR_DUES = 'Repay your dues.'
}

export enum FAQ_ICON {
  INTEREST_RATE_ICON_FAQ = 'INTEREST_RATE_ICON_FAQ',
  REPAY_ICON = 'REPAY_ICON',
  CASH_WITHDRAWAL = 'CASH_WITHDRAWAL',
  COLLATERAL_SECURITIES = 'COLLATERAL_SECURITIES',
  RENEWAL_ICON = 'RENEWAL_ICON',
  HELP_AND_SUPPORT = 'HELP_AND_SUPPORT',
}

export enum DSP_PAYMENT_STATUS {
  SUCCESS = 'SUCCESS',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  EXEEDED = 'EXEEDED',
  COLLECTION_COMPLETE = 'COLLECTION_COMPLETE',
  SETTLED = 'SETTLED'
}


export const isMobileView = () => {
  const Breakpoint = 1024
  if (Platform.OS === 'web') {
    if (window?.outerWidth < Breakpoint) {
      return true
    } else {
      return false
    }
  }
  return true
}


export const isCurrentTimeAfterSixPM = () => {
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const currentTimeInMinutes = hours * 60 + minutes;
  const sixPMInMinutes = 18 * 60;
  let isAfterSixPM = false;
  if (currentTimeInMinutes > sixPMInMinutes) {
    isAfterSixPM = true;
  }
  return isAfterSixPM;
}

export const determineBaseOrigin = () => {
  if(Platform.OS === 'web') {
    return window?.location?.href
  }
  else{
    return 'https://app.voltmoney.in/mandateCallback?redirect=true&showVoltDefaultHeader=false'
  }
}

export const removeStartNew = () => {
  if(Platform.OS === 'web') {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    let pathSuffix = '';

    for (const [key, value] of params.entries()) {
      if (key === 'startNew') {
        const split = value.split('/');
        if (split.length > 1) {
          pathSuffix = '/' + split.slice(1).join('/');
        }
        params.delete('startNew');
        break;
      }
    }

    const remainingParams = [];
    for (const [key, value] of params.entries()) {
      remainingParams.push(`${key}=${value}${pathSuffix}`);
      pathSuffix = ''; // only apply suffix to first param after removal
    }
    const newQuery = remainingParams.length ? `?${remainingParams.join('&')}` : '';

    const finalUrl = `${url.origin}${url.pathname}${newQuery}`;
    window.history.replaceState({}, '', finalUrl);
  }
}


export const removeUrlWithoutReload = (param: string) => {
  if(Platform.OS === 'web') {
    const url = new URL(window.location.href)
    url.searchParams.delete(param)
    window.history.pushState(null, '', url.toString())
  }
}

export const removePathFromUrlWithouReload = (param: string) => {
  if(Platform.OS === 'web') {
    const url = window.location.href;
    const newUrl = url.replace(param, '');
    window.history.replaceState(null, '', newUrl);
  }
}

export const isFromMFDShareLinkJourneyPartnerSide = () => {
  const params:any = Platform.OS === 'web' ? getParameters(window?.location?.href) : '';
  const context = params[QUERY_PARAMS.CONTEXT];
  const platform = params[QUERY_PARAMS.PLATFORM];
  const isCustomer = params[QUERY_PARAMS.IS_CUSTOMER];
  if (isCustomer === "true") {
    return false;
  }
  if (shareLinkAllowedPlatform(platform)) {
    return true;
  }
  if(context === 'PARTNER') {
      return true;
  } else {
      return false;
  }
}

export const removeQueryFromUrlWithoutReloadV2 = (param: string) => {
  if(Platform.OS === 'web') {
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    window.history.replaceState(null, '', url.toString());
  }
};

export const addOrUpdateParam = (url: string, key: string, value: string) => {
  const urlObj = new URL(url);
  urlObj.searchParams.set(key, value);
  return urlObj.toString();
}

export const isIframe = (): boolean => {
  try {
      return window && window.self !== window.top;
  } catch (e) {
      return true;
  }
}

export const mandateReRegistrationFlag = (firebaseParams: any, currentUserPhoneNumber: string) => {
    //MASTER FLAG CHECK
    if(firebaseParams?.MANDATE_RE_REGISTER_FEATURE === 'true' || firebaseParams?.MANDATE_RE_REGISTER_FEATURE === true) {
      return true;
    }

    //TEST NUMBER FLAG CHECK
    currentUserPhoneNumber = currentUserPhoneNumber && currentUserPhoneNumber?.slice(3);
    const testNumberStringConfig  = firebaseParams?.MANDATE_RE_REGISTER_FEATURE_TEST_NUMBERS;
    try{
      if(testNumberStringConfig) {
        const testNumberJson = JSON.parse(testNumberStringConfig);
        if(testNumberJson?.test_numbers?.includes(currentUserPhoneNumber) === true) {
          return true;
        }
      }
    } catch (err) {
      console.log("Error: ", err)
    }

    return false;
}

export function throttle<T extends (...args: any[]) => void>(func: T, limit: number) {
  let inThrottle: boolean;
  return function (this: any, ...args: Parameters<T>) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  } as T;
}

export const getContactNumberForWhatsapp = (platformName: string , defaultNumber : string) => {
    switch (platformName) {
      case 'FREO':
        return '916364465607';
      case 'SDK_INVESTWELL':
        return '917795402425';
      default:
        return defaultNumber;
    }
  };


export const getContactNumberForCall = (platformName: string , finalContactSupportNumber : string) => {
    if (platformName === 'FREO') {
      return '+916364465607';
    } else {
      return `+91${finalContactSupportNumber}`;
    }
};

export const getLabelForCall = (platformName: string , finalContactSupportNumber: string) => {
    if (platformName === 'FREO') {
      return '63644 65607';
    } else {
      return finalContactSupportNumber;
    }
};

export const getTermsLinks = () => {
    return `${VoltWebSiteBaseLink}terms?showHeader=false`
}

export const getPrivacyLinks = () => {
    return `${VoltWebSiteBaseLink}privacy?showHeader=false`
}



export const emailDefferingFlag = () => {
  const firebaseParams = store?.getState()?.firebaseParams;
  // Return null if Firebase params haven't been loaded yet
  if (!firebaseParams?.isParamsUpdated) {
    return null;
  }
  let currentUserPhoneNumber = store?.getState()?.auth?.userDetails?.user?.phoneNumber;
  //MASTER FLAG CHECK
  if (firebaseParams?.email_deferring_feature_flag === 'true' || firebaseParams?.email_deferring_feature_flag === true) {
    return true;
  }
  // TEST NUMBER FLAG CHECK
  currentUserPhoneNumber = currentUserPhoneNumber && currentUserPhoneNumber?.slice(3);
  const testNumberStringConfig  = firebaseParams?.email_deferring_feature_test_numbers;
  try{
    if(testNumberStringConfig) {
      const testNumberJson = JSON.parse(testNumberStringConfig);
      if(testNumberJson?.test_numbers?.includes(currentUserPhoneNumber) === true) {
        return true;
      }
    }
  } catch (err) {
    console.log("Error: ", err)
  }

  return false;
}



export const shareLinkAllowedPlatform = (targetPlatform: string) => {
  const firebaseParams = store?.getState()?.firebaseParams?.sharelink_allowed_platform;
  try {
    const firebaseParamsJson = JSON.parse(firebaseParams);
    if (firebaseParamsJson && firebaseParamsJson.sharelink_allowed_platform && firebaseParamsJson.sharelink_allowed_platform?.length > 0) {
      return firebaseParamsJson.sharelink_allowed_platform?.includes(targetPlatform);
    }
  } catch (err) {
    console.log("Error: ", err)
  }
  return false;
}

export const showWhatsappButton = (showCall?: boolean, platform?: string) => {

  const firebaseParams = store?.getState()?.firebaseParams;
  const whatsappButtonHiddenPlatforms = firebaseParams?.hide_platform_whatsapp;

  try {
    const platformCode = JSON.parse(whatsappButtonHiddenPlatforms)?.platformCode;
    if(platformCode?.includes(platform) && showCall === false) {
      return false;
    } 
    else return true;
  } catch(err){
    console.log("Error: ", err)
    return true;
  }
}

export const isLASFlowEnabled = () => {
  const firebaseParams = store?.getState()?.firebaseParams;
  console.log('firebaseParams', firebaseParams)
  try{
    const isLasFlowEnabled = JSON.parse(firebaseParams?.is_Las_Flow_Enabled);
    if(isLasFlowEnabled === 'true' || isLasFlowEnabled === true) {
      return true;
    } else {
      return false;
    }
  } catch(err){
    console.log("Error: ", err)
    return false;
  } 
}